function getTransporterInputTypes() {
  return {
    LIST: 1,
    UPDATE_LORRY_RECEIPT: 2,
    ADD_POD: 3,
    ASSIGN_TRUCK: 4,
    UPDATE_TRUCK: 5,
    UPDATE_RFQ: 5,
    CHANGE_VEHICLE_TYPE: 6,
    DELIVER: 7,
    GRN_UPDATE: 8,
    CHANGE_VEHICLE_ETA: 9,
    REJECT: 10,
    TRUCK_IN: 11,
    TRUCK_OUT: 12,
    UPDATE_CONTAINER_DETAILS: 13,
    INSPECTION: 14,
    ADD_INSPECTION_ATTACHMENT: 15,
    IS_VEHICLE_OR_PHONE_NUMBER_EXISTS: 16,
    IS_DUPLICATE_VEHICLE_ASSIGN: 17,
    RETURN_MATERIALS: 18,
    UPDATE_MATERIAL_INVOICE_LR: 19,
  };
}

const transporterConstants = {
  validTransporterHeaders: {
    'Transporter Name*': 'vname',
    'Reference ID*': 'ref_id',
    Address: 'address',
    City: 'city',
    State: 'state',
    'Postal Code': 'pincode',
    Manager: 'rname',
    'Representative Mobile': 'rmobile',
    'Representative Email*': 'remail',
    GSTIN: 'gst_gstin',
    'Gst type(FCM/RCM)*': 'gst_type',
    'Percentage*': 'percentage',
    'GST State': 'gst_state',
    'GST Reference ID': 'gst_ref_id',
  },
  exportAndRejectionHeaders: {
    'Transporter Name*': 'vname',
    'Reference ID*': 'ref_id',
    'Gst type(FCM/RCM)*': 'gst_type',
    'Percentage*': 'percentage',
    Manager: 'rname',
    'Representative Mobile': 'rmobile',
    'Representative Email*': 'remail',
    Address: 'address',
    City: 'city',
    State: 'state',
    'Postal Code': 'pincode',
    'GST State': 'gst_state',
    GSTIN: 'gst_gstin',
    'GST Reference ID': 'gst_ref_id',
    'PAN Number': 'pan_no',
    Status: 'status',
    'Credit Period': 'credit_period',
    MSME: 'msme',
    'GST ACK No.': 'ack_no',
    'GST ACK Date': 'ack_date',
    'Associated Depot Reference': 'associate_depot_ref'
  },
  optionalTransporterHeaders: {
    'GST ACK No.': 'ack_no',
    'GST ACK Date': 'ack_date',
    'PAN Number': 'pan_no',
    Status: 'status',
    'Credit Period': 'credit_period',
    MSME: 'msme',
    'Associated Depot Reference': 'associate_depot_ref'
  },
  lrHeaders: {
    'Generate LR': 'generate_lr',
    'Auto Extend LR Series': 'auto_extend_lr_series',
  },
};

module.exports = { getTransporterInputTypes, transporterConstants };
